export const EIA_SCHEMA_VERSION = 'eia-config.v1';

const toArray = (value) => {
  if (Array.isArray(value)) return value;
  if (value && typeof value === 'object') return Object.values(value);
  return [];
};

const normalizeQuestion = (question = {}, index = 0) => {
  const id = question.id || question.video || `q${index + 1}`;
  const text = question.text || question.q || '';
  const video = question.video || id;
  return {
    ...question,
    id,
    video,
    text,
    q: text,
  };
};

export const normalizeEiaScriptDocument = (rawDoc = {}, context = {}) => {
  const source = rawDoc || {};
  const scriptCandidate =
    source?.script?.questions ? source.script
      : source?.script?.script?.questions ? source.script.script
        : source?.questions ? source
          : source?.script ? source.script
            : {};

  const flowCandidate = source?.flow || source?.script?.flow || source?.script?.script?.flow || null;
  const questions = toArray(scriptCandidate?.questions).map(normalizeQuestion);

  return {
    schemaVersion: source.schemaVersion || EIA_SCHEMA_VERSION,
    meta: {
      sourceCompany: source._scriptSourceCompany || context.company || null,
      interviewType: context.interviewType || scriptCandidate?.tipo || null,
      version: context.version || source.version || scriptCandidate?.version || null,
      normalizedAt: new Date().toISOString(),
    },
    script: {
      ...scriptCandidate,
      questions,
      tipo: scriptCandidate?.tipo || context.interviewType || 'pesquisa-de-compliance',
      version: scriptCandidate?.version || context.version || 'v1',
      avatars: Array.isArray(scriptCandidate?.avatars) ? scriptCandidate.avatars : [],
    },
    flow: flowCandidate,
    questionsCount: questions.length,
    raw: source,
  };
};
